/* eslint-disable @typescript-eslint/no-namespace */
import { USTreasury } from '../types/treasuries.types';
import { Maturity } from '../types/deal.types';
import { getMomentsFormatter } from '../utils/formatters/value-mappers';

export namespace USTreasuries {
  export const treasuryLabelMap = {
    US12M: '1y',
    US2Y: '2y',
    US3Y: '3y',
    US5Y: '5y',
    US7Y: '7y',
    US10Y: '10y',
    US30Y: '30y',
  };

  export const treasuryLabels = [
    'US12M',
    'US2Y',
    'US3Y',
    'US5Y',
    'US7Y',
    'US10Y',
    'US30Y',
  ];

  export const treasuryYearMap = [
    'US12M',
    'US12M',
    'US2Y',
    'US3Y',
    'US5Y',
    'US5Y',
    'US7Y',
    'US7Y',
    'US10Y',
    'US10Y',
    'US10Y',

    'US10Y',
    'US10Y',
    'US10Y',
    'US10Y',
    'US10Y',

    'US30Y',
    'US30Y',
    'US30Y',
    'US30Y',
    'US30Y',

    'US30Y',
    'US30Y',
    'US30Y',
    'US30Y',
    'US30Y',
    'US30Y',
    'US30Y',
    'US30Y',
    'US30Y',
    'US30Y',
    'US30Y',
  ];

  export function getTreasuryDataForYear(
    usTreasuries: USTreasury[],
    matYear: number,
    yearShift?: string
  ): USTreasury {
    let result: USTreasury;
    if (matYear && usTreasuries) {
      const currentYear = new Date().getFullYear();
      const index = matYear - currentYear;

      const id =
        yearShift ||
        (index > -1 && index < treasuryYearMap.length
          ? treasuryYearMap[index]
          : index > 0
          ? treasuryYearMap[treasuryYearMap.length - 1]
          : null);

      result = usTreasuries.find((item) => item.securityId === id);
    }

    return result;
  }

  export function getTreasuryLabel(treasuryYear: string): string {
    return treasuryYear ? treasuryLabelMap[treasuryYear] : '';
  }

  export function getTreasuryYearShift(maturityYear: number): number {
    const currentYear = new Date().getFullYear();
    const index = maturityYear - currentYear;
    const securityId = treasuryYearMap[index];
    const yearShift = treasuryLabels.indexOf(securityId);
    return yearShift;
  }

  export function impliedYieldForMaturityVisible(data: Maturity): boolean {
    return data && ((isNaN(data.coupon) && !data.coupon) || !data.yield);
  }

  export function impliedSpreadForMaturityVisible(data: Maturity): boolean {
    return (
      data &&
      (!!data.coupon || !!data.yield) &&
      !(
        data.taxableTsySpread ||
        data.taxableTsySpread === 0 ||
        data.taxableTreasurySpread ||
        data.taxableTreasurySpread === 0
      )
    );
  }

  export function impliedYieldForSeriesVisible(
    maturities: Maturity[],
    seriesId: string
  ): boolean {
    let result = false;
    if (!!seriesId && !!maturities && maturities.length > 0) {
      result = maturities
        .filter((mat) => mat.seriesId === seriesId)
        .some((mat) => {
          const ustSpread = mat
            ? mat.taxableTsySpread || mat.taxableTreasurySpread
            : null;
          const taxableTsyMat = mat ? mat.taxableTsyMat : null;
          const taxableTsyCoupon = mat ? mat.taxableTsyCoupon : null;

          return (
            USTreasuries.impliedYieldForMaturityVisible(mat) ||
            ((!taxableTsyMat || !ustSpread || !taxableTsyCoupon) &&
              ((!mat.coupon && mat.coupon !== 0) || !mat.yield)) ||
            (!!ustSpread && (!!mat.coupon || !!mat.yield))
          );
        });
    }
    return result;
  }

  export function impliedSpreadForSeriesVisible(
    maturities: Maturity[],
    seriesId: string
  ): boolean {
    let result = false;
    if (!!seriesId && !!maturities && maturities.length > 0) {
      result = maturities
        .filter((mat) => mat.seriesId === seriesId)
        .some((mat) => {
          return impliedSpreadForMaturityVisible(mat);
        });
    }
    return result;
  }

  export function mapImpliedSpreadViewModel(
    maturity,
    maturities: Maturity[],
    impliedSpreadYearShift: { id: string; yearShift: number }
  ) {
    if (
      USTreasuries.impliedSpreadForSeriesVisible(maturities, maturity.seriesId)
    ) {
      const maturityYear = new Date(
        getMomentsFormatter()(maturity.chartDate)
      ).getFullYear();
      const initialYearShift = USTreasuries.getTreasuryYearShift(maturityYear);
      if (
        (impliedSpreadYearShift &&
          impliedSpreadYearShift.id === undefined &&
          impliedSpreadYearShift.yearShift === undefined) ||
        maturity.id !== (impliedSpreadYearShift || ({} as { id })).id
      ) {
        const impliedSpreadData = {
          initialYearShift: initialYearShift,
          yearShift: initialYearShift,
        };
        maturity = { ...maturity, impliedSpreadData };
      } else if (maturity.id === impliedSpreadYearShift.id) {
        maturity = {
          ...maturity,
          impliedSpreadData: {
            initialYearShift: initialYearShift,
            yearShift: impliedSpreadYearShift.yearShift,
          },
        };
      }
    }
    return maturity;
  }
}
